import { React } from 'react';
import Modal from 'react-bootstrap/Modal';
import { RxCross2 } from 'react-icons/rx';
import './styles.css';
import { AddEvent } from '../event/add-event';
export function AddUpcomingEventModal({
  show,
  handleClose,
  updateNotificationsList,
  setUpdateNotificationsList,
  setIsAnnoucementReload,
}) {
  return (
    <Modal
      className='featureSectionModal modal-dialog-centered'
      show={show}
      onHide={handleClose}
      size='lg'
      centered={true}
    >
      <Modal.Header className='pb-0'>
        <Modal.Title id='example-modal-sizes-title-sm' className='font-18'>
          {updateNotificationsList ? 'Update Event' : 'Add Event'}
        </Modal.Title>
        <button
          onClick={() => {
            handleClose(false);
            setUpdateNotificationsList(false);
          }}
          className='cross-button'
        >
          <RxCross2 size={30} className='btn_cross' />
        </button>
      </Modal.Header>

      <div className='modal-body'>
        <div id='notificationSection' className='chartSection mb-4'>
          <AddEvent
            updateNotificationsList={updateNotificationsList}
            setUpdateNotificationsList={setUpdateNotificationsList}
            setIsAnnoucementReload={setIsAnnoucementReload}
            handleClose={handleClose}
            show={show}
          />
        </div>
      </div>
    </Modal>
  );
}
